module.exports = __webpack_public_path__ + "img/660.8db2a7f2.jpg";